import React from "react";
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import { DataGrid } from "@mui/x-data-grid";
import ReuseableButton from "../../../components/Buttons/button";
import useWardTableHook from "./wardFetchHook";
import { userColumns } from "./wardColumn";

const WardTable = () => {
    const { wardState, handleDelete, handleAddWard , loader} = useWardTableHook()

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <div
              className="deleteButton"
              onClick={(e) => handleDelete(e, params.row)}
              >
              Delete
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className='d-flex justify-content-end'>
        <div className="mr-5">
          <ReuseableButton
            text={"Add Ward"}
            height={45}
            colorVarient="success"
            fullWidthFlag={true}
            endIcon={<PersonAddAltIcon />}
            handleChange={handleAddWard}
          />
        </div>
      </div>
      <div className="datatable">
        <DataGrid
          checkboxSelection={false}
          className="datagrid"
          rows={wardState?.length > 0 ? wardState : []}
          columns={userColumns.concat(actionColumn)}
          rowsPerPageOptions={[10]}
          getRowId={(row) => row.uniqueId}
          loading={loader ? loader : false}
          disableSelectionOnClick
          experimentalFeatures={{ newEditingApi: true }}
        //   onPageChange={(newPageSize) => handlePagination(newPageSize)}
          initialState={wardState}
          pagination
          pageSize={10}
          disableColumnMenu={true}
        />
      </div>
    </>
  )
}

export default WardTable;
